module.exports = __webpack_public_path__ + "img/Icon12_05.ad4fb269.svg";